import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL || "https://dashboard.lono.co.in/api";

// Create axios instance with interceptors
const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor to include token
api.interceptors.request.use(
  (config) => {
    const token = 
      localStorage.getItem("token") || 
      sessionStorage.getItem("token") ||
      localStorage.getItem("adminToken") ||
      localStorage.getItem("staffToken") ||
      localStorage.getItem("subAdminToken");
    
    console.log("TaskAPI - Available tokens:", {
      token: localStorage.getItem("token") ? 'exists' : 'none',
      adminToken: localStorage.getItem("adminToken") ? 'exists' : 'none',
      staffToken: localStorage.getItem("staffToken") ? 'exists' : 'none',
      subAdminToken: localStorage.getItem("subAdminToken") ? 'exists' : 'none'
    });
    console.log("TaskAPI - Using token:", token ? token.substring(0, 20) + '...' : 'none');
    
    // Decode token to check user role
    if (token) {
      let payload = null;
      try {
        payload = JSON.parse(atob(token.split('.')[1]));
        console.log("Token payload:", payload);
        console.log("User role from token:", payload.role);
      } catch (e) {
        console.log("Could not decode token:", e);
      }
      config.headers.Authorization = `Bearer ${token}`;
      // Map role to server expected format
      if (payload?.role) {
        let serverRole = payload.role;
        if (payload.role === 'admin') {
          serverRole = 'Admin';
        } else if (payload.role === 'staff') {
          serverRole = 'staff';
        } else if (payload.role === 'subAdmin') {
          serverRole = 'subAdmin';
        }
        config.headers['X-User-Role'] = serverRole;
        config.headers['X-User-ID'] = payload.userId;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const taskAPI = {
  // Create a new task
  createTask: async (taskData) => {
    try {
      // Map frontend types to backend allowed enum values
      const typeMapping = {
        'DOCUMENT_VERIFICATION': 'DOCUMENT_VERIFICATION',
        'INCOME_VERIFICATION': 'INCOME_VERIFICATION',
        'LEGAL_CHECK': 'LEGAL_CHECK',
        'CREDIT_CHECK': 'CREDIT_CHECK',
        'LOAN_PROCESSING': 'LOAN_PROCESSING',
        'PROPERTY_VERIFICATION': 'DOCUMENT_VERIFICATION',
        'BUSINESS_ANALYZER': 'DOCUMENT_VERIFICATION',
        'BANK_STATEMENT_ANALYZER': 'DOCUMENT_VERIFICATION',
        'CREDIT_ANALYZER': 'CREDIT_CHECK',
        'EMPLOYMENT_PAYSLIP_ANALYZER': 'INCOME_VERIFICATION',
        'ITR_ANALYZER': 'INCOME_VERIFICATION',
        'LOAN_STATEMENT_ANALYZER': 'LOAN_PROCESSING',
        'RENTAL_AGREEMENT_ANALYZER': 'DOCUMENT_VERIFICATION',
        'BUSINESS_LICENSE_ANALYZER': 'DOCUMENT_VERIFICATION',
        'PROPERTY_DOCUMENT_ANALYZER': 'DOCUMENT_VERIFICATION',
        'EVALUATION_ANALYZER': 'DOCUMENT_VERIFICATION',
        'GENERAL': 'GENERAL'
      };
      
      // Map the type to allowed backend value
      if (taskData.type && typeMapping[taskData.type]) {
        taskData.type = typeMapping[taskData.type];
      } else {
        taskData.type = 'GENERAL'; // Default fallback
      }
      
      console.log("Creating task with data:", taskData);
      const response = await api.post("/tasks/create", taskData);
      return response.data;
    } catch (error) {
      console.log("Task creation failed:", error.response?.data || error.message);
      throw error.response?.data || error.message;
    }
  },

  // Get tasks for a staff member
  getStaffTasks: async (staffId) => {
    try {
      const response = await api.get(`/tasks/staff/${staffId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update task status
  updateTaskStatus: async (taskId, statusData) => {
    try {
      const response = await api.put(`/tasks/${taskId}/status`, statusData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};